import FooterText from "../Footer/Footer";
import LeftPanel from "../LeftPanel/LeftPanel";
import { useEffect, useContext } from "react";
import { MyContext } from "../../MyContext";
import { useNavigate } from "react-router-dom";

const PrivacyPolicy = () => {

  const { onPage, setOnPage } = useContext(MyContext)!;
  useEffect(() => {
    setOnPage(window.location.pathname.substring(1));
  }, []);

  return (
    <>
      <div className="mobile-pro">
        <div className="login">
          <img src="img/issue-icon-default.svg" />
          <h2>Privacy Policy</h2>
        </div>
      </div>
    </>
  );
};

export default PrivacyPolicy;
